export default __webpack_public_path__ + "static/media/478.d861a79f.png";